export const WHEEL_DIAMETER_10 = 10;
export const TYPE_OF_INCIDENT_12 = 12;
export const INSURANCE_TYPE = 13;
export const VEHICLE_TYPES_15 = 15;
export const CLIENT_STATUS_TYPE = 27;
export const SOURCE_TYPE = 36; // глобальный справочник источников (используется в заявках, чеках, счетах и т.п.)
export const REPAIR_PARTS = 54;
export const TIRE_OPERATIONS_56 = 56;
export const INVOICE_DOCUMENT_TYPE = 68;
export const BODY_TYPE_78 = 78;
export const RIM_TYPE_80 = 80;
export const RIM_ORIGIN_81 = 81;
export const STORED_OBJECT_79 = 79;
export const TIRE_WIDTH_83 = 83;
export const TIRE_HEIGHT_82 = 82;
export const DOC_TEMPLATE_TYPE = 86;
export const BANNER_TYPE_94 = 94;
export const INVOICE_STATUS_66 = 66;
